import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";

export const useGetV4PricingPlanReportOptions = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  return queryOptions({
    queryKey: [{ entity: "V4PricingPlanReportByPlan", marketPlace }],
    queryFn: async () =>
      await apiClient.getV4PricingPlanReportByOptions({
        queries: {
          marketplace: marketPlace,
        },
      }),
    placeholderData: keepPreviousData,
  });
};
